<template>
    <div class="layout layout--blank">
        <nuxt />
        <system-notifications :notifications="notifications" />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import config from '@/config';
import { StorySlug } from '@/enums';
import SystemNotifications from '@/components/SystemNotifications';
import ContentService from '@/services/content.service';
import MetadataService from '@/services/metadata.service';
import AbTestService from '@/services/ab-test.service';

export default {
    name: 'BlankLayout',
    components: {
        SystemNotifications,
    },
    async fetch() {
        try {
            const abTestService = new AbTestService(this.$cookies);
            const contentService = new ContentService(this.$storyapi, abTestService, this.$logger);
            const story = await contentService.getStory({
                story: StorySlug.Metadata,
                version: this.$storyblokHelper.version,
                locale: this.$i18n.locale,
                hasFallback: true,
            });

            const metadata = contentService.makeMetadataModel(story.content);
            const metadataService = new MetadataService(
                {
                    defaultMetatags: metadata.metatags,
                    i18nSeo: this.$nuxtI18nSeo(),
                    url: `${config.host}${this.$route.fullPath}`,
                    title: metadata.siteTitle,
                },
                this.$logger,
            );
            this.metadata = metadataService.getMetadata({ isCookieBannerEnabled: this.showCookieBanner });
        } catch (error) {
            this.$logger.error({ msg: 'error.blankLayout.fetch', error });
        }
    },
    data() {
        return {
            metadata: {},
        };
    },
    computed: {
        ...mapState('notifications', ['notifications']),
        ...mapGetters('main', ['showCookieBanner']),
    },
    head() {
        return this.metadata;
    },
};
</script>

<style lang="scss" scoped>
.layout {
    &--blank {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
}
</style>
